// HCRender.jsx
// Fragment loading system for HelpCenter - supports project-level overrides.
// Project can override any fragment by placing a file with the same name in:
//   components/HelpCenter/fragments/<FragmentName>.jsx

const defaultFragments = import.meta.glob(
  "aldoo-ra/HelpCenter/fragments/*.jsx",
  { eager: true }
)
const projectFragments = import.meta.glob(
  "@components/HelpCenter/fragments/*.jsx",
  { eager: true }
)

const getComponentName = (path) => {
  const parts = path.split("/fragments/")
  return parts[1].replace(".jsx", "")
}

const DEFAULT_FRAGMENTS = Object.entries(defaultFragments).reduce(
  (acc, [path, module]) => {
    acc[getComponentName(path)] = module.default
    return acc
  },
  {}
)

const PROJECT_FRAGMENTS = Object.entries(projectFragments).reduce(
  (acc, [path, module]) => {
    acc[getComponentName(path)] = module.default
    return acc
  },
  {}
)

export default class HCRender {
  static getFragment(name) {
    return PROJECT_FRAGMENTS[name] || DEFAULT_FRAGMENTS[name] || null
  }
}
